import React from 'react';
import { CheckOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { formatDateTime } from '../../../Utils/dateFormat';
import {
  Trail,
  TimelineItem,
  TimelineDot,
  TimelineHead,
  TimelineAct,
  TimelineWho,
  TimelineTime,
  TimelineComment,
  EmptyState
} from './AuditDetailStyles';

const kindOf = event => {
  const who = (event.userType || '').toLowerCase();
  const act = (event.status || event.action || '').toLowerCase();
  if (who.includes('ai') || act.includes('ai ') || act.includes('generat'))
    return 'ai';
  if (who.includes('system')) return 'sys';
  if (act.includes('complet')) return 'done';
  return 'done';
};

const startMs = event => {
  const ms = event.startTime ? new Date(event.startTime).getTime() : NaN;
  return Number.isNaN(ms) ? -Infinity : ms;
};

// The API returns events newest-first; the trail reads left → right, so show
// them oldest-first. Events without a startTime lead; ties keep API order.
const chronological = events =>
  events
    .map((event, index) => ({ event, index }))
    .sort((a, b) => startMs(a.event) - startMs(b.event) || a.index - b.index)
    .map(({ event }) => event);

/**
 * Horizontal provenance timeline, oldest → newest left to right, for a job's audit events
 * (from fetchJobAuditDataByJobId result[]).
 */
const AuditTimeline = ({ events = [] }) => {
  if (!events.length) {
    return <EmptyState>No audit events recorded.</EmptyState>;
  }
  return (
    <Trail>
      {chronological(events).map((event, index) => {
        const kind = kindOf(event);
        const action = event.status || event.action || 'Event';
        const who = event.userName || event.userType || '—';
        return (
          <TimelineItem key={index} kind={kind}>
            <TimelineDot kind={kind}>
              {kind === 'ai' ? (
                <ThunderboltOutlined style={{ fontSize: 11 }} />
              ) : (
                <CheckOutlined style={{ fontSize: 11 }} />
              )}
            </TimelineDot>
            <TimelineHead>
              <TimelineAct>{action}</TimelineAct>
              <TimelineWho>{who}</TimelineWho>
            </TimelineHead>
            <TimelineTime>
              {event.startTime ? formatDateTime(event.startTime) : '—'}
              {event.endTime && event.endTime !== event.startTime
                ? ' → ' + formatDateTime(event.endTime)
                : ''}
            </TimelineTime>
            {event.comment && (
              <TimelineComment>{event.comment}</TimelineComment>
            )}
          </TimelineItem>
        );
      })}
    </Trail>
  );
};

export default AuditTimeline;
